export default "__VITE_PUBLIC_ASSET__5dadd29a__"